import React from "react";
import { Bot } from "../types/bot.type";
import getCoinImage from "../utils/getCoinImage";
import { getCoinName } from "../utils/getCoinName";
import {
  IonButton,
  IonButtons,
  IonLabel,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import SaveStrategyButton from "./SaveStrategyButton";

interface Props {
  bot: Bot;
  onDismiss?: () => void;
}

const ConfigSummary: React.FC<Props> = ({ bot, onDismiss }) => {
  return (
    <div className="rounded-xl bg-primary-90 ">
      {onDismiss && (
        <>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton fill="clear" onClick={onDismiss}>
                <IonLabel className="text-white">Cancel</IonLabel>
              </IonButton>
            </IonButtons>
            <IonTitle className="text-white">{bot?.name} Strategy</IonTitle>
          </IonToolbar>
          <div className="px-4 text-right">
            <SaveStrategyButton bot={bot} />
          </div>
        </>
      )}
      <div className="flex flex-col justify-center bg-primary-70 rounded-xl px-8 py-4 m-4 text-white">
        <h1 className="text-white font-semibold text-2xl pb-2">Global</h1>

        <div className="flex items-center mb-2">
          <div className="font-semibold">Quote Asset:</div>
          <div className="ml-2 flex items-center px-4">
            <img
              src={getCoinImage(bot?.quoteAsset)}
              alt={bot?.quoteAsset}
              className="w-8 h-8 rounded-full object-cover mx-2"
            />
            <b>{getCoinName(bot?.quoteAsset)}</b>
          </div>
        </div>
        <div className="flex flex-wrap items-center">
          <div className="font-semibold pr-8 mb-2">Whitelist:</div>
          {bot.whitelist.map((coin, index) => (
            <div key={index} className={`mb-2 ${index > 0 ? "-ml-2" : "ml-1"}`}>
              <img
                src={getCoinImage(coin)}
                alt={coin}
                className="w-[32px] h-[32px] rounded-full"
              />
            </div>
          ))}
        </div>
        <div className="flex items-center py-3">
          <div className="font-semibold pr-8">Ticker Interval:</div>
          <div className="font-bold">{bot.tradeParameters.tickerInterval}</div>
        </div>
      </div>

      <div className="flex flex-col justify-center bg-primary-70 rounded-xl px-8 py-4 m-4 text-white">
        <h1 className="text-white font-semibold text-2xl pb-2">Buy</h1>
        {/* BUY RSI */}
        <div className="flex items-center mb-2">
          <div className="font-semibold pr-8">RSI:</div>
          <div className="font-bold">
            {
              bot.tradeParameters.buy.strategies.find(
                strategy => strategy.name === "rsi"
              )?.threshold
            }
          </div>
        </div>
        {/* TRADE RATIO */}
        <div className="flex items-center mb-2">
          <div className="font-semibold pr-8">Trade Ratio:</div>
          <div className="font-bold">{bot.tradeParameters.tradeRatio} %</div>
        </div>
        {/* TRADE SLOTS */}
        <div className="flex items-center">
          <div className="font-semibold pr-8">Trade Slots:</div>
          <div className="font-bold">
            {bot.tradeParameters.buy.maxOpenTrades}
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-center bg-primary-70 rounded-xl px-8 py-4 m-4 text-white">
        <h1 className="text-white font-semibold text-2xl pb-2">Sell</h1>
        {/* SELL RSI */}
        {bot.tradeParameters.sell.strategies.find(
          strategy => strategy.name === "rsi"
        ) && (
          <div className="flex items-center mb-2">
            <div className="font-semibold pr-8">RSI:</div>
            <div className="font-bold">
              {bot.tradeParameters.sell.strategies.find(
                strategy => strategy.name === "rsi"
              )?.threshold || "DISABLED"}
            </div>
          </div>
        )}
        {/* STOP LOSS */}
        {bot.tradeParameters.sell.strategies.find(
          strategy => strategy.name === "stopLoss"
        ) && (
          <div className="flex items-center mb-2">
            <div className="font-semibold pr-8">Stop Loss:</div>
            <div className="font-bold">
              {bot.tradeParameters.sell.strategies.find(
                strategy => strategy.name === "stopLoss"
              )?.threshold + " % " || "DISABLED"}
            </div>
          </div>
        )}

        {/* TAKE PROFIT */}
        <div className="flex items-center">
          <div className="font-semibold pr-8">Profit Margin:</div>
          <div className="font-bold">
            {bot.tradeParameters.sell.strategies.find(
              strategy => strategy.name === "profitMargin"
            )?.threshold + " % " || "DISABLED"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfigSummary;
